export var IDLE = 'IDLE';
export var DONE = 'DONE';
export var ERROR = 'ERROR';
export var RELOADING = 'RELOADING';
export var PRELOADING = 'PRELOADING';
